import env from '@/config/env';

export default {
  type: 'datepicker',
  format: 'DD/MM/YYYY',
  // defaultValue: env.DEFAULT_DATE_RANGE,
  label: 'global.text.date',
  locale: true,
  name: 'dateRange',
};
